import { render, staticRenderFns } from "./project-management.vue?vue&type=template&id=f3a13910&scoped=true&"
import script from "./project-management.vue?vue&type=script&lang=js&"
export * from "./project-management.vue?vue&type=script&lang=js&"
import style0 from "./project-management.vue?vue&type=style&index=0&id=f3a13910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a13910",
  null
  
)

export default component.exports